const initialState = {
  stockOuts: [],
  GatePassDta: [],
  loading: false,
  actionLoading: false,
  gatePassLoading: false,
  error: null
};

const StockOutReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_STOCKOUTS_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_STOCKOUTS_SUCCESS':
      return { ...state, loading: false, stockOuts: action.payload, error: null };

    case 'FETCH_STOCKOUTS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'ADD_STOCKOUTS_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'ADD_STOCKOUTS_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        stockOuts: [action.payload, ...state.stockOuts],
        error: null
      };

    case 'ADD_STOCKOUTS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'GENERATE_GATE_PASS_REQUEST':
      return { ...state, gatePassLoading: true, error: null };

    case 'GENERATE_GATE_PASS_SUCCESS':
      return { ...state, gatePassLoading: false, GatePassDta: action.payload, error: null };

    case 'GENERATE_GATE_PASS_FAILURE':
      return { ...state, gatePassLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default StockOutReducer;
